import type { NewParlay, TrackParlayResult } from '@hooks/useTrackedParlays';
import { createContext } from 'react';

/** The app's track function, so a chat card can track a generated parlay by its ids. */
export const ChatTrackContext = createContext<
  ((parlay: NewParlay) => Promise<TrackParlayResult>) | null
>(null);
